import React, { useEffect, useState } from 'react';
import * as api from '~/Services/Service';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import ModalProspectoVinculoTag from './ProspectoVinculoTag/ModalProspectoVinculoTag';
import Loading from '~/Components/Loading';
import { Row, Col, Button, Modal, Card } from 'react-bootstrap';
import { FaEye, FaPen, FaPlus, FaTrash, FaSearch } from 'react-icons/fa';
import './TagAtendimento.css';
import { CaretDown } from 'phosphor-react';

export default function TagsAtendimento() {
  const initialModalState = {
    open: false,
    mode: 'add',
    tag: null,
  };

  const initialDeleteState = {
    open: false,
    tag: null,
  };

  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [orderBy, setOrderBy] = useState('');
  const [order, setOrder] = useState('asc');
  const [modal, setModal] = useState(initialModalState);
  const [deleteModal, setDeleteModal] = useState(initialDeleteState);
  const [descricaoTag, setDescricaoTag] = useState('');
  const [modalVinculos, setModalVinculos] = useState({ open: false });
  const [modoMobile, setModoMobile] = useState(window.innerWidth <= 768);
  const [expandedCard, setExpandedCard] = useState(null);

  useEffect(() => {
    fetchTags();
  }, [page, pageSize, orderBy, order]);

  useEffect(() => {
    function handleResize() {
      setModoMobile(window.innerWidth <= 768);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  async function fetchTags() {
    setLoading(true);
    try {
      const params = {
        descricao: filter,
        pagina: page,
        tamanho_pagina: pageSize || 10,
        order_by: orderBy,
        order,
      };
      const data = await api.BuscarTagsAtendimento(params);

      setTags(data || []);
      setTotal(data.length > 0 ? data[0].total_registros : 0);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }

  const handleSearch = () => {
    fetchTags();
  };

  function handleOpenAdd() {
    setModal({ open: true, mode: 'add', tag: null });
    setDescricaoTag('');
  }

  function handleOpenEdit(tag) {
    setModal({ open: true, mode: 'edit', tag });
    setDescricaoTag(tag.descricao);
  }

  function handleCloseModal() {
    setModal(initialModalState);
    setDescricaoTag('');
  }

  function handleOpenDelete(tag) {
    setDeleteModal({ open: true, tag });
  }

  function handleCloseDelete() {
    setDeleteModal(initialDeleteState);
  }

  async function handleSaveTag(e) {
    try {
      e.preventDefault();
      setLoading(true);

      const edit = modal.mode === 'add' ? false : true;

      const request = {
        codigo: modal.tag ? modal.tag.codigo : 0,
        descricao: descricaoTag,
      };

      if (edit) {
        await api.AtualizarTagAtendimento(request);
      } else {
        await api.InserirTagAtendimento(request);
      }

      handleCloseModal();
      toast.success(
        'Tag ' +
          descricaoTag +
          (edit ? ' atualizada' : ' inserida') +
          ' com sucesso!'
      );
      fetchTags();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleDeleteTag() {
    setLoading(true);

    try {
      if (deleteModal.tag.quantidade_vinculos > 0) {
        toast.error(
          'Não é possível excluir uma tag que possui vínculos com algum prospecto'
        );
        return;
      }
      const request = {
        codigo: deleteModal.tag.codigo,
      };
      await api.ExcluirTagATendimento(request);

      handleCloseDelete();
      toast.success(`Tag ${deleteModal.tag.descricao} excluída com sucesso!`);
      fetchTags();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleSort(col) {
    if (orderBy === col) {
      setOrder(order === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(col);
      setOrder('asc');
    }
  }

  return (
    <div className="container-fluid tags-atendimento-root">
      <div className="container">
        <div className="page-header">
          <h2>Tags de Atendimento</h2>
        </div>

        <div className="search-section">
          <Row className="g-3 align-items-end">
            <Col xs={12} md={8} lg={6}>
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control search-input flex-grow-1"
                  placeholder="Filtrar por nome da tag..."
                  value={filter}
                  onChange={e => setFilter(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSearch();
                    }
                  }}
                  maxLength={100}
                />
                <Button
                  onClick={handleSearch}
                  className="btn btn-custom btn-primary-custom d-flex align-items-center ml-2"
                  style={{ gap: 6 }}
                >
                  <FaSearch size={12} />
                  <span className="ml-1">Pesquisar</span>
                </Button>
              </div>
            </Col>
            <Col
              xs={12}
              md={4}
              lg={6}
              className="d-flex justify-content-md-end"
            >
              <button
                onClick={handleOpenAdd}
                className="btn btn-custom btn-success-custom  d-flex align-items-center mt-1"
              >
                <FaPlus size={12} color="white" />
                <span className="ml-1" style={{ color: 'white' }}>
                  Adicionar Tag
                </span>
              </button>
            </Col>
          </Row>
        </div>

        {!modoMobile && (
          <div className="table-container">
            <table className="table table-custom">
              <thead>
                <tr>
                  <th
                    onClick={() => handleSort('codigo')}
                    style={{ cursor: 'pointer' }}
                  >
                    Código
                    {orderBy === 'codigo' && (
                      <CaretDown
                        size={16}
                        className={`sort-icon ${
                          order !== 'asc' ? 'expanded' : ''
                        }`}
                        style={{
                          transition: 'transform 0.3s',
                          transform:
                            order !== 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('descricao')}
                    style={{ cursor: 'pointer' }}
                  >
                    Nome
                    {orderBy === 'descricao' && (
                      <CaretDown
                        size={16}
                        className={`sort-icon ${
                          order !== 'asc' ? 'expanded' : ''
                        }`}
                        style={{
                          transition: 'transform 0.3s',
                          transform:
                            order !== 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </th>
                  <th
                    onClick={() => handleSort('QuantidadeVinculos')}
                    style={{ cursor: 'pointer' }}
                  >
                    Quantidade de vínculos
                    {orderBy === 'QuantidadeVinculos' && (
                      <CaretDown
                        size={16}
                        className={`sort-icon ${
                          order !== 'asc' ? 'expanded' : ''
                        }`}
                        style={{
                          transition: 'transform 0.3s',
                          transform:
                            order !== 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="4" className="">
                      <Loading />
                    </td>
                  </tr>
                ) : tags.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="empty-state">
                      Nenhuma tag encontrada.
                    </td>
                  </tr>
                ) : (
                  tags.map(tag => (
                    <tr key={tag.codigo}>
                      <td>
                        <span style={{ fontWeight: '600', color: '#475569' }}>
                          {tag.codigo}
                        </span>
                      </td>
                      <td>
                        <span style={{ fontWeight: '500', color: '#1e293b' }}>
                          {tag.descricao}
                        </span>
                      </td>
                      <td>
                        <span
                          className="quantity-link"
                          style={{ fontWeight: '600', fontSize: '1.1rem' }}
                        >
                          {tag.quantidade_vinculos}
                        </span>
                        {tag.quantidade_vinculos > 0 && (
                          <FaEye
                            className="eye-icon"
                            size={16}
                            onClick={() => {
                              setModalVinculos({
                                open: true,
                                codigo_tag: tag.codigo,
                                descricao_tag: tag.descricao,
                              });
                            }}
                          />
                        )}
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            onClick={() => handleOpenEdit(tag)}
                            className="btn-icon btn-icon-primary"
                            title="Editar"
                          >
                            <FaPen size={14} />
                          </button>
                          <button
                            onClick={() => handleOpenDelete(tag)}
                            className="btn-icon btn-icon-danger ml-1"
                            title="Excluir"
                          >
                            <FaTrash size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {modoMobile && (
          <>
            <div className="mobile-header">
              <Row>
                <Col>
                  <span
                    onClick={() => handleSort('descricao')}
                    className="label-header"
                  >
                    Nome
                    {orderBy === 'descricao' && (
                      <CaretDown
                        size={16}
                        style={{
                          transition: 'transform 0.3s',
                          transform:
                            order !== 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </span>
                </Col>
                <Col className="d-flex justify-content-end">
                  <span
                    onClick={() => handleSort('QuantidadeVinculos')}
                    className="label-header"
                  >
                    Vínculos
                    {orderBy === 'QuantidadeVinculos' && (
                      <CaretDown
                        size={16}
                        style={{
                          transition: 'transform 0.3s',
                          transform:
                            order !== 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      />
                    )}
                  </span>
                </Col>
              </Row>
            </div>

            {loading ? (
              <div>
                <Loading />
              </div>
            ) : tags.length === 0 ? (
              <div className="empty-state">Nenhuma tag encontrada.</div>
            ) : (
              tags.map(tag => (
                <div key={tag.codigo} className="mobile-card">
                  <div
                    className="mobile-card-body d-flex justify-content-between align-items-center"
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      setExpandedCard(
                        expandedCard === tag.codigo ? null : tag.codigo
                      )
                    }
                  >
                    <div>
                      <div className="mobile-card-title">{tag.descricao}</div>
                      <div className="mobile-card-subtitle">
                        Código: {tag.codigo}
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <span className="mobile-card-badge">
                        {tag.quantidade_vinculos}
                      </span>
                      <CaretDown
                        size={22}
                        className={`expand-icon ${
                          expandedCard === tag.codigo ? 'expanded' : ''
                        }`}
                      />
                    </div>
                  </div>
                  {expandedCard === tag.codigo && (
                    <div className="mobile-card-expanded">
                      <div className="mb-3">
                        <span style={{ color: '#64748b', fontWeight: '500' }}>
                          {tag.quantidade_vinculos}{' '}
                          {tag.quantidade_vinculos > 1 ? 'Vínculos' : 'Vínculo'}
                        </span>
                        {tag.quantidade_vinculos > 0 && (
                          <FaEye
                            className="eye-icon"
                            size={16}
                            onClick={e => {
                              e.stopPropagation();
                              setModalVinculos({
                                open: true,
                                codigo_tag: tag.codigo,
                                descricao_tag: tag.descricao,
                              });
                            }}
                          />
                        )}
                      </div>
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleOpenEdit(tag);
                          }}
                          className="btn-icon btn-icon-primary"
                          title="Editar"
                        >
                          <FaPen size={14} />
                        </button>
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleOpenDelete(tag);
                          }}
                          className="btn-icon btn-icon-danger ml-1"
                          title="Excluir"
                        >
                          <FaTrash size={14} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </>
        )}

        <div className="pagination-container">
          <Row className="align-items-center g-3">
            <Col xs="auto">
              <button
                onClick={() => setPage(p => Math.max(1, p - 1))}
                disabled={page === 1}
                className="btn btn-custom btn-outline-custom btn-sm-custom"
              >
                Anterior
              </button>
            </Col>
            <Col xs="auto">
              <span className="pagination-info">Página {page}</span>
            </Col>
            <Col xs="auto">
              <button
                onClick={() => setPage(p => (p * pageSize < total ? p + 1 : p))}
                disabled={page * pageSize >= total}
                className="btn btn-custom btn-outline-custom btn-sm-custom"
              >
                Próxima
              </button>
            </Col>
            <Col xs="auto">
              <select
                value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value));
                  setPage(1);
                }}
                className="pagination-select"
              >
                {[10, 20, 50].map(size => (
                  <option key={size} value={size}>
                    {size} por página
                  </option>
                ))}
              </select>
            </Col>
            <Col xs="auto">
              <span className="pagination-info">Total: {total}</span>
            </Col>
          </Row>
        </div>

        {modal.open && (
          <Modal
            show={modal.open}
            onHide={handleCloseModal}
            backdrop="static"
            centered
          >
            <form onSubmit={handleSaveTag}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {modal.mode === 'add' ? 'Adicionar Tag' : 'Editar Tag'}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label form-label-custom">
                    Descrição da Tag:
                  </label>
                  <input
                    type="text"
                    value={descricaoTag}
                    onChange={e => setDescricaoTag(e.target.value)}
                    required
                    className="form-control form-control-custom"
                    placeholder="Digite a descrição da tag..."
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={handleCloseModal}
                  className="btn-custom btn-outline-custom"
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  className="btn-custom btn-primary-basic"
                >
                  Salvar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        )}

        {deleteModal.open && (
          <Modal
            show={deleteModal.open}
            onHide={handleCloseDelete}
            backdrop="static"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Excluir Tag</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p style={{ color: '#475569', fontSize: '1.1rem' }}>
                Tem certeza que deseja excluir a tag{' '}
                <strong style={{ color: '#1e293b' }}>
                  "{deleteModal.tag.descricao}"
                </strong>
                ?
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseDelete}
                className="btn-custom btn-outline-custom"
              >
                Não
              </Button>
              <Button
                variant="danger"
                onClick={handleDeleteTag}
                className="btn-custom btn-danger-custom"
              >
                Sim
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {modalVinculos.open && (
          <ModalProspectoVinculoTag
            show={modalVinculos.open}
            onHide={() => {
              setModalVinculos({ open: false });
            }}
            infos={modalVinculos}
            modoMobile={modoMobile}
          />
        )}
      </div>
    </div>
  );
}
